import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e874230"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input" };
const _hoisted_2 = {
    key: 0,
    class: "label_zone"
};
const _hoisted_3 = { class: "text" };
import { computed, ref, watch } from 'vue';
import InvalidField from '../atoms/InvalidField.vue';
import Text from '../atoms/Text.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        label: { default: '' },
        placeholder: { default: '' },
        readonly: { type: Boolean, default: false },
        isPassword: { type: Boolean, default: false },
        regexp: null,
        invalidMessage: { default: '' },
        required: { type: Boolean, default: false },
        reference: { default: '' },
        hasError: { type: Boolean, default: false },
        defaultValue: { default: '' }
    },
    emits: ["validate", "update:reference"],
    setup(__props, { emit }) {
        const props = __props;
        const text = ref(props.defaultValue);
        const textComputed = computed({
            get: () => text.value,
            set: (value) => {
                emit('update:reference', value);
            },
        });
        const isRegInvalid = ref(false);
        const isEmpty = ref(false);
        watch([text], () => {
            /* 必須項目チェック */
            isEmpty.value = props.required && !text.value;
            /* 正規表現のチェック */
            if (props.regexp) {
                const reg = new RegExp(props.regexp);
                isRegInvalid.value = props.regexp && !reg.test(text.value);
            }
            emit('validate', isEmpty.value || isRegInvalid.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.label)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(props.label), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(Text, {
                        reference: _unref(textComputed),
                        "onUpdate:reference": _cache[0] || (_cache[0] = ($event) => (_isRef(textComputed) ? (textComputed).value = $event : null)),
                        placeholder: props.placeholder,
                        "is-password": __props.isPassword,
                        required: props.required,
                        readonly: props.readonly
                    }, null, 8, ["reference", "placeholder", "is-password", "required", "readonly"])
                ]),
                _createVNode(InvalidField, {
                    "is-invalid": isRegInvalid.value,
                    message: props.invalidMessage
                }, null, 8, ["is-invalid", "message"]),
                _createVNode(InvalidField, {
                    "is-invalid": isEmpty.value,
                    message: "Required field"
                }, null, 8, ["is-invalid"]),
                _createVNode(InvalidField, {
                    "is-invalid": __props.hasError,
                    message: props.invalidMessage
                }, null, 8, ["is-invalid", "message"])
            ]));
        };
    }
});
